<template>
    <div>
        <span class="filters__ref"></span>
        <div class="filters__content">
            <div class="filters__content-title" style="">
                <b class="filters__title" @click="openFilter = !openFilter">{{ openFilter ? `Ocultar
                                    filtros`: `Mostrar filtros` }}
                </b> <i><font-awesome-icon :icon="closeIcon" style="font-size:1.5rem;margin-top: 4px;" />
                </i>
            </div>
            <div class="filters__container-ranges" v-if="openFilter">
                <slot></slot>
            </div>
        </div>
    </div>
</template>
<script>
import { faFilter } from "@fortawesome/free-solid-svg-icons";
export default {
    name: 'FilterMobile',
    data() {
        return {
            closeIcon: faFilter,
            openFilter: false
        }
    },
    methods: {
        handleScroll() {
            if (window.matchMedia("(max-width: 1200px)")) {

                let filterMobile = document.querySelector('.availables-mobile .filters__ref')
                if (filterMobile) {
                    let contentFilter = document.querySelector('.availables-mobile .filters__content')
                    var elementPosition = filterMobile.getBoundingClientRect().top;
                    if (elementPosition > 0) {
                        contentFilter.classList.remove('filters__mobile-fixed');
                    } else {
                        contentFilter.classList.add('filters__mobile-fixed');
                        this.openFilter= false;
                    }
                }

            }
        }
    },
    mounted(){
        window.addEventListener("scroll", this.handleScroll);
    }
}
</script>
<style scoped>
.filters__content-title {
    justify-content: flex-end;
    display: flex;
    align-items: center;
    padding: 10px
}

.filters__title {
    font-size: 1.4rem;
    border-bottom: 2px solid black;
    margin-right: 5px;
    cursor: pointer
}

.filters__content {
    width: 100%;
}

.filters__mobile-fixed {
    position: fixed;
    top: 0;
    background-color: white;
    z-index: 3;
}
.filters__container-ranges{
    padding-bottom:15px
}
</style>